import { motion } from 'framer-motion';

const fadeUp = {
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: '-50px' },
    transition: { duration: 0.6, ease: 'easeOut' },
};

export function PainSection() {
    return (
        <section data-testid="pain-section" className="bg-[#F8F9FA] py-24 md:py-32">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-4xl md:text-5xl text-navy-900 mb-8 tracking-tight">
                        What Staying This Busy Actually Costs You
                    </h2>
                    <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                        <p>
                            There's a version of success that looks good on paper and feels terrible in real life. You're closing deals. The income is there. But so is the Sunday anxiety. The missed dinners. The vacation you keep postponing. The feeling that if you stop moving, everything falls apart.
                        </p>
                        <p>
                            You tell yourself it's temporary. That next quarter you'll hire someone. That you just need one more good year before you can slow down.
                        </p>
                        <p>
                            But the agents who say that at $20M are still saying it at $40M. The business doesn't get easier by getting bigger. It gets harder - unless you build it differently.
                        </p>
                        <p>
                            The cost of staying in this pattern isn't just time. It's your health. Your relationships. Your ability to enjoy what you've worked this hard to build. You're paying for expensive leads and letting them drift because you're too buried in operations to follow up. Some agents start thinking about walking away from a career they used to love - not because real estate is broken, but because the way they're running it is unsustainable.
                        </p>
                        <p className="text-navy-900 font-montserrat font-bold text-xl">
                            That's not a production problem. That's a leverage problem.
                        </p>
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
